import { getTasks } from '../../../../Requests/tasks/tasks';
export interface SubgramTask {
  task_id: string;
  title: string;
  description: string;
  btn_text: string;
  image_url: string;
  link: string;
  icon: string;
  status: string;
  task_type: string;
  details: {
    task_id: string;
    resource_logo: string;
    link: string;
  };
  rewards: Array<{
    amount: number;
  }>;
  provider: 'FLYER' | 'SUBGRAM';
  user_metadata: {
    status: 'NOT_STARTED' | 'IN_PROGRESS' | 'WAITING' | 'DONE' | 'CLAIMED';
  };
}

export interface SubgramStatusTask {
  details: {
    task_id: string;
  };
  task_id: string;
  user_metadata: {
    status: 'NOT_STARTED' | 'IN_PROGRESS' | 'WAITING' | 'DONE' | 'CLAIMED';
  };
}
export interface TaskDetails {
  id: string;
  title: string;
  description: string;
  icon: string;
  type: string;
  rewards: {
    beastcoins: number;
  };
  status: 'NOT_STARTED' | 'IN_PROGRESS' | 'WAITING' | 'DONE' | 'CLAIMED';
  buttonText: string;
  link: string;
  progress: {
    current: number;
    total: number;
  };
  provider: string;
}

export class SubgramAdapter {
  static async getFeed(): Promise<SubgramTask[]> {
    try {
      const res = await getTasks('partner', 'subgram');
      console.log('📦 Получены задания от Subgram:', res);
      const tasks = (Array.isArray(res) ? res : []) as SubgramTask[];

      return tasks
        .map((task: SubgramTask) => ({
          // Явно указываем тип task
          ...task,
          provider: 'SUBGRAM' as const,
        }))
        .filter((t) => t.task_type !== 'give boost');
    } catch (error) {
      console.error('❌ Ошибка получения заданий от Subgram:', error);
      return [];
    }
  }

  static async getStatusTasks(): Promise<SubgramStatusTask[]> {
    try {
      const res = await getTasks('partner', 'subgram');
      const statusTasks = (
        Array.isArray(res) ? res : []
      ) as SubgramStatusTask[];

      console.log('📋 Статусы заданий Subgram (внешний запрос):', statusTasks);
      return statusTasks;
    } catch (error) {
      console.error(
        '❌ Ошибка получения статусов заданий Subgram (внешний запрос):',
        error,
      );
      return [];
    }
  }

  static async adaptTasks(
    flyerTasks: SubgramTask[],
    statusTasks?: SubgramStatusTask[],
  ): Promise<TaskDetails[]> {
    console.log('🔄 SubgramAdapter.adaptTasks - start', { flyerTasks });
    console.log(
      '🔄 - - - - - - SubgramAdapter.adaptTasks - statusTasks:',
      this.getStatusTasks(),
    );

    try {
      const currentStatusTasks = statusTasks ?? (await this.getStatusTasks());
      console.log('📋 Текущие статусы заданий Subgram:', currentStatusTasks);

      const adaptedTasks = flyerTasks.reduce<TaskDetails[]>((acc, task) => {
        // Ищем statusTask с правильным сопоставлением ID
        const taskId = task.task_id || task.details?.task_id;
        const statusTask = currentStatusTasks.find((st) => {
          const statusTaskId = st.task_id || st.details?.task_id;
          return statusTaskId === taskId;
        });

        const status = (statusTask?.user_metadata.status || 'NOT_STARTED') as
          | 'NOT_STARTED'
          | 'IN_PROGRESS'
          | 'WAITING'
          | 'DONE'
          | 'CLAIMED';

        // если image_url = null, используем дефолтное изображение
        const image_url = task.details?.resource_logo || '';

        // Определяем текст кнопки на основе статуса
        let buttonText = 'Выполнить';
        if (status === 'CLAIMED') {
          buttonText = 'Выполнено';
        } else if (status === 'DONE') {
          buttonText = 'Получить';
        } else if (status === 'WAITING') {
          buttonText = 'Ожидание';
        } else if (status === 'IN_PROGRESS') {
          buttonText = 'В процессе';
        }

        acc.push({
          id: task.details.task_id,
          title: task.title,
          description: task.description,
          icon: image_url,
          type: 'partners',
          rewards: {
            beastcoins: task.rewards[0].amount,
          },
          status,
          buttonText,
          link: task.details.link,
          progress: {
            current: 0,
            total: 1,
          },
          provider: 'SUBGRAM',
        });

        return acc;
      }, []);

      return adaptedTasks;
    } catch (error) {
      console.error('❌ Ошибка при адаптации заданий Subgram:', error);
      return [];
    }
  }
}
